import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { BiLinkExternal } from "react-icons/bi";

import usmog from "../../Assets/usmog.png";
import nitrofx from "../../Assets/nitrofx.png";
import topmark from "../../Assets/topmark.png";
import reelwood from "../../Assets/reelwood...png";
import camdad from "../../Assets/camdad.png";
import votweb from "../../Assets/SmartVote.jpeg";
import techcamp from "../../Assets/techcamp.png";
import currencyconverter from "../../Assets/currencyconverter.png";
import aiimagegenerator from "../../Assets/aiimagegenerator.png";
import codegpt from "../../Assets/codegpt.png";

function Projects(props) {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My  <strong className="purple">Portfolio </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            
           <a href="https://github.com/Dimkpa-Daniel/Smart-Vote-App" style={{textDecoration: "none"}} target="_blank"> <ProjectCard
              imgPath={votweb}
              isBlog={false}
              title="SMART VOTE"
              description="This is a real time voting app built with react. With this app users can only vote once. It also has an admin page where election and candidadtes can be created as well."
            

            />
            </a>
          
          </Col>

          <Col md={4} className="project-card">
          <a href="https://d-codegpt.netlify.app/" style={{textDecoration: "none"}} target="_blank">   <ProjectCard
              imgPath={codegpt}
              isBlog={false}
              title="A MODEL OF CHAT GPT"
              description="This is a web application that was created using the Openai API for chat gpt. The web applications mimic's the caht gpt."
          
            />
              </a>
          </Col>

          <Col md={4} className="project-card">
          <a href="https://nitrofxcapital.netlify.app/" style={{textDecoration: "none"}} target="_blank"> <ProjectCard
              imgPath={nitrofx}
              isBlog={false}
              title="NITRO FX."
              description="This website is basically a place where people get to make investment, monitor their progress, etc"
         
            />
            </a>
          </Col>

          <Col md={4} className="project-card">
          <a href="https://topmarkfurniture.com/" style={{textDecoration: "none"}} target="_blank">   <ProjectCard
              imgPath={topmark}
              isBlog={false}
              title="TOPMARK"
              description="This  website was built for the sole purpose of promoting and marketing products"
           
            />
            </a>
          </Col>

          <Col md={4} className="project-card">
          <a href="https://camdad.netlify.app/" style={{textDecoration: "none"}} target="_blank"> <ProjectCard
              imgPath={camdad}
              isBlog={false}
              title="CAMDAD"
              description="Camdad is an online platform owned and managed by Camdad Investment Ltd and established and incorporated in Nigeria."
             
            />
            </a>
          </Col>

          <Col md={4} className="project-card">
          <a href="https://www.reelwood.ng/" style={{textDecoration: "none"}} target="_blank">  <ProjectCard
              imgPath={reelwood}
              isBlog={false}
              title="ONLINE EVENT TICKETING WEBSITE"
              description="All the basic CRUD operation of Create, Read, Update and Delete were implemented in this website. Just the way it's needed."
         
            />
            </a>
          </Col>

        <Col md={4} className="project-card">
          <a href="https://aceploratechcamp.netlify.app/" style={{textDecoration: "none"}} target="_blank">  <ProjectCard
              imgPath={techcamp}
              isBlog={false}
              title="A TECHCAMP WEBSITE"
              description="This is a techcamp website where you can browse the techcamp course you want and make payment for it. This project usses supabase"
         
            />
            </a>
          </Col>

             <Col md={4} className="project-card">
          <a href="https://d-currencyconverter.netlify.app/" style={{textDecoration: "none"}} target="_blank">  <ProjectCard
              imgPath={currencyconverter}
              isBlog={false}
              title="A CURRENCY CONVERTER WEB APP."
              description="This is a web application that converts currencies of different countries. More like an exchange rate platform."
         
            />
            </a>
          </Col>

     <Col md={4} className="project-card">
          <a href="https://ai-imagegenerator.netlify.app/" style={{textDecoration: "none"}} target="_blank">  <ProjectCard
              imgPath={aiimagegenerator}
              isBlog={false}
              title="AN AI IMAGE GENERATOR WEB APP."
              description="This is a web application that makes use of an AI to generate images for users."
         
            />
            </a>
          </Col>
            
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
